"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _networkErrors = _interopRequireDefault(require("MeetingsLib/redux/reducers/networkErrors"));

var _branding = _interopRequireDefault(require("MeetingsLib/redux/reducers/branding"));

var _bookingLifecycle = _interopRequireDefault(require("MeetingsLib/redux/reducers/bookingLifecycle"));

var _portalId = _interopRequireDefault(require("MeetingsLib/redux/reducers/portalId"));

var _portalAuth = _interopRequireDefault(require("MeetingsLib/redux/reducers/portalAuth"));

var _initialFormState = _interopRequireDefault(require("MeetingsLib/redux/reducers/initialFormState"));

var _stagedFormState = _interopRequireDefault(require("MeetingsLib/redux/reducers/stagedFormState"));

var _formState = _interopRequireDefault(require("MeetingsLib/redux/reducers/formState"));

var _bookInfo = _interopRequireDefault(require("MeetingsLib/redux/reducers/bookInfo"));

var _isSalesStarter = _interopRequireDefault(require("MeetingsLib/redux/reducers/isSalesStarter"));

var _calendarProvider = _interopRequireDefault(require("MeetingsLib/redux/reducers/calendarProvider"));

var _profile = _interopRequireDefault(require("MeetingsLib/redux/reducers/profile"));

var _userMessage = _interopRequireDefault(require("MeetingsLib/redux/reducers/userMessage"));

var _userTimezone = _interopRequireDefault(require("MeetingsLib/redux/reducers/userTimezone"));

var _requestStatus = _interopRequireDefault(require("MeetingsLib/redux/reducers/requestStatus"));

var _activeLocale = _interopRequireDefault(require("MeetingsLib/redux/reducers/activeLocale"));

var _companyName = _interopRequireDefault(require("MeetingsLib/redux/reducers/companyName"));

var _stagedLegalConsentResponses = _interopRequireDefault(require("MeetingsLib/redux/reducers/stagedLegalConsentResponses"));

var _legalConsentResponses = _interopRequireDefault(require("MeetingsLib/redux/reducers/legalConsentResponses"));

var _troubleshooting = _interopRequireDefault(require("MeetingsLib/redux/reducers/troubleshooting"));

var _legitimateInterestConfirmed = _interopRequireDefault(require("MeetingsLib/redux/reducers/legitimateInterestConfirmed"));

var _default = (0, _redux.combineReducers)({
  requestStatus: _requestStatus.default,
  bookingLifecycle: _bookingLifecycle.default,
  networkErrors: _networkErrors.default,
  branding: _branding.default,
  portalId: _portalId.default,
  portalAuth: _portalAuth.default,
  initialFormState: _initialFormState.default,
  stagedFormState: _stagedFormState.default,
  formState: _formState.default,
  bookInfo: _bookInfo.default,
  isSalesStarter: _isSalesStarter.default,
  calendarProvider: _calendarProvider.default,
  profile: _profile.default,
  userMessage: _userMessage.default,
  userTimezone: _userTimezone.default,
  activeLocale: _activeLocale.default,
  companyName: _companyName.default,
  stagedLegalConsentResponses: _stagedLegalConsentResponses.default,
  legalConsentResponses: _legalConsentResponses.default,
  troubleshooting: _troubleshooting.default,
  legitimateInterestConfirmed: _legitimateInterestConfirmed.default,
  trackingParams: function trackingParams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  prefilledCustomFormFields: function prefilledCustomFormFields() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  userSlug: function userSlug() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  embedded: function embedded() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  forceOffline: function forceOffline() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  forcePropertyForm: function forcePropertyForm() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  queryParams: function queryParams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  currentTime: function currentTime() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  initTrackingForMeetings: function initTrackingForMeetings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  onSuccess: function onSuccess() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emptyFunction.default;
    return state;
  },
  onFailure: function onFailure() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emptyFunction.default;
    return state;
  },
  forceMobile: function forceMobile() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  parentPageHSAnalyticsInfo: function parentPageHSAnalyticsInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  allowTroubleshootMode: function allowTroubleshootMode() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  allowRedirect: function allowRedirect() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  disablePrefill: function disablePrefill() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  }
});

exports.default = _default;
module.exports = exports.default;